import { useEffect, type FC } from 'react';
import { datadog } from 'dibs-datadog/exports/datadog';
import {
    perfMeasureFromPageInit,
    perfSubGroupStart,
    perfSubGroupEnd,
    PAGE_INIT_MARK,
    perfMeasure,
} from 'dibs-tracking/src/prometheus/peformanceTracking';

type SharedPerformanceTrackerProps = {
    datadogTimer?: {
        name: string;
        time?: number;
    };
    measure?: Parameters<typeof perfMeasure>[0];
    measureFromPageInit?: Parameters<typeof perfMeasureFromPageInit>[0];
    subGroupStart?: Parameters<typeof perfSubGroupStart>[0];
    subGroupEnd?: Parameters<typeof perfSubGroupEnd>[0];
};

export const SharedPerformanceTracker: FC<SharedPerformanceTrackerProps> = ({
    datadogTimer,
    measure,
    measureFromPageInit,
    subGroupStart,
    subGroupEnd,
}) => {
    useEffect(() => {
        if (measure) {
            const startMark = perfSubGroupStart.getMark(measure.subGroup);
            // This component might be a leaf in a tree where the start mark hasn't been set
            // Fail silently so as to not pollute the console with errors
            // Devs should be verifying their analytics in the network "other" tab
            if (performance.getEntriesByName(startMark).length > 0) {
                perfMeasure(measure);
            }
        }
        if (measureFromPageInit) {
            const startMark = perfSubGroupStart.getMark(PAGE_INIT_MARK);
            if (performance.getEntriesByName(startMark).length > 0) {
                perfMeasureFromPageInit(measureFromPageInit);
            }
        }
        if (subGroupStart) {
            perfSubGroupStart(subGroupStart);
        }
        if (subGroupEnd) {
            perfSubGroupEnd(subGroupEnd);
        }
        datadog.load().then(dd => {
            if (datadogTimer && dd && dd.getGlobalContext()) {
                dd.addTiming(datadogTimer.name, datadogTimer.time);
            }
        });
    }, [datadogTimer, measure, subGroupStart, subGroupEnd, measureFromPageInit]);

    return null;
};
